import { useCallback, useState } from "react";
import { COLORS } from "../constants/app";
import { useSession } from "./SessionContext";

interface UseApiRequestOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
  showSuccessNotification?: boolean;
  successMessage?: string;
}

export const useApiRequest = <T = any>() => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [data, setData] = useState<T | null>(null);
  const { setSesionInvalida, mostrarNotificacion } = useSession();

  const executeRequest = useCallback(
    async (requestFn: () => Promise<T>, options: UseApiRequestOptions = {}) => {
      setLoading(true);
      setError(null);

      try {
        const result = await requestFn();
        setData(result);

        if (options.showSuccessNotification && options.successMessage) {
          mostrarNotificacion(true, options.successMessage, COLORS.SUCCESS);
        }

        options.onSuccess?.(result);
        return result;
      } catch (e: any) {
        // Manejo centralizado de errores 401
        if (e.response?.status === 401) {
          setSesionInvalida(true);
        } else {
          const errorMessage = e.response?.data?.message || e.message || "Error desconocido";
          setError(new Error(errorMessage));
          mostrarNotificacion(true, `Error: ${errorMessage}`, COLORS.ERROR);
          options.onError?.(e);
        }
        throw e;
      } finally {
        setLoading(false);
      }
    },
    [setSesionInvalida, mostrarNotificacion]
  );

  return { executeRequest, loading, error, data };
};
